import { render, staticRenderFns } from "./ClinicsNavTabs.vue?vue&type=template&id=eb1117b6&scoped=true"
import script from "./ClinicsNavTabs.vue?vue&type=script&lang=js"
export * from "./ClinicsNavTabs.vue?vue&type=script&lang=js"
import style0 from "./ClinicsNavTabs.vue?vue&type=style&index=0&id=eb1117b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1117b6",
  null
  
)

export default component.exports